import {colors} from "patient-ping-remedy/packages/theme";
import styled from '@emotion/styled';

const StyledDisclaimerText = styled('div')`
  color: ${colors.yellow5};
  max-width: 60rem;
  font-size: 1.5rem;
`;


export { StyledDisclaimerText };
